(() => {
  const setupHero = (root) => {
    const slides = [...root.querySelectorAll('[data-goodlot-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-goodlot-hero-dot]')];
    const slidesViewport = root.querySelector('[data-goodlot-hero-slides]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length < 2 || !slidesViewport) return;

    let index = 0;
    let timer;
    let pointerStartX = null;

    const show = (nextIndex, direction = 1) => {
      const normalizedIndex = (nextIndex + slides.length) % slides.length;
      if (normalizedIndex === index) return;

      const currentSlide = slides[index];
      const nextSlide = slides[normalizedIndex];

      root.classList.toggle('is-reversing', direction < 0);
      currentSlide.classList.add('is-exiting');
      currentSlide.classList.remove('is-active');
      currentSlide.setAttribute('aria-hidden', 'true');
      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');

      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === normalizedIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      window.setTimeout(() => currentSlide.classList.remove('is-exiting'), 480);
      index = normalizedIndex;
    };

    const restartTimer = () => {
      window.clearInterval(timer);
      if (reduceMotion || root.dataset.autoplay !== 'true') return;
      timer = window.setInterval(() => show(index + 1, 1), 5600);
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        show(dotIndex, dotIndex > index ? 1 : -1);
        restartTimer();
      });
    });

    slidesViewport.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });

    slidesViewport.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const delta = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(delta) < 40) return;
      show(index + (delta < 0 ? 1 : -1), delta < 0 ? 1 : -1);
      restartTimer();
    });

    slidesViewport.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });

    restartTimer();
  };

  document.querySelectorAll('[data-goodlot-hero]').forEach(setupHero);
})();
